import React, { useEffect, useState } from 'react';

const CustomCursor = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isVisible, setIsVisible] = useState(false);
  const [isClicking, setIsClicking] = useState(false);

  useEffect(() => {
    let rafId = null;
    let lastX = 0;
    let lastY = 0;
    let tolerance = 0.1; 

    const updatePosition = (e) => {
      if (rafId) {
        cancelAnimationFrame(rafId);
      }

      rafId = requestAnimationFrame(() => {
        if (Math.abs(e.clientX - lastX) > tolerance || Math.abs(e.clientY - lastY) > tolerance) {
          lastX = e.clientX;
          lastY = e.clientY;
          setPosition({ x: e.clientX, y: e.clientY });
        }
        
        if (!isVisible) {
          setIsVisible(true);
        }
      });
    };

    const handleMouseDown = () => setIsClicking(true);
    const handleMouseUp = () => setIsClicking(false);
    const handleMouseLeave = () => setIsVisible(false);
    const handleMouseEnter = () => setIsVisible(true);

    document.addEventListener('mousemove', updatePosition, { passive: true });
    document.addEventListener('mousedown', handleMouseDown, { passive: true });
    document.addEventListener('mouseup', handleMouseUp, { passive: true });
    document.addEventListener('mouseleave', handleMouseLeave, { passive: true });
    document.addEventListener('mouseenter', handleMouseEnter, { passive: true });

    return () => {
      document.removeEventListener('mousemove', updatePosition);
      document.removeEventListener('mousedown', handleMouseDown);
      document.removeEventListener('mouseup', handleMouseUp);
      document.removeEventListener('mouseleave', handleMouseLeave);
      document.removeEventListener('mouseenter', handleMouseEnter);
      
      if (rafId) {
        cancelAnimationFrame(rafId);
      }
    };
  }, [isVisible]);

  const dotStyle = {
    transform: `translate(${position.x - 3}px, ${position.y - 3}px)`,
    opacity: isVisible ? 1 : 0,
    position: 'fixed',
    pointerEvents: 'none',
  };

  const cursorStyle = {
    transform: `translate(${position.x - 10}px, ${position.y - 10}px) scale(${isClicking ? 0.8 : 1})`,
    opacity: isVisible ? 1 : 0,
    // transition: "opacity 0.15s ease, transform 0.15s ease",
    position: 'fixed',
    pointerEvents: 'none',
  };

  return (
    <>
      <div className="custom-cursor" style={cursorStyle} />
      <div className="cursor-dot" style={dotStyle} />
    </>
  );
};

export default CustomCursor;